import { twMerge } from "tailwind-merge";
import { tagClassName, tagSize } from "./constants";
import {
  TAG_COLOR,
  TAG_SIZE,
  TAG_STATUS,
  TAG_STYLE,
  TAG_TYPE,
  TagProps,
} from "./types";

const useTagStyles = ({
  style = TAG_STYLE.FILL,
  size = TAG_SIZE.LARGE,
  color = TAG_COLOR.DEFAULT,
  type = TAG_TYPE.SQUARE,
  startIcon,
  endIcon,
  showTagClose,
  className,
  select,
  disableActiveClass,
}: TagProps) => {
  const tagStatusValues = Object.values(TAG_STATUS).filter(
    (status) => !(disableActiveClass && status === TAG_STATUS.SELECTED)
  );

  const buttonColorClassNames = tagStatusValues.reduce((prev, status) => {
    const colorSchema = tagClassName[color][style][status];

    return (
      prev +
      `${colorSchema.bg || ""} ${colorSchema.border || ""} ${
        colorSchema.text || ""
      } `
    );
  }, "");

  const selectedClassName = tagClassName[color][style][TAG_STATUS.SELECTED];

  return twMerge(
    tagSize[size][type],
    buttonColorClassNames,
    startIcon || endIcon || showTagClose ? "flex items-center gap-1.5" : "",
    className,
    select && selectedClassName.bg.replace(/active:/g, ""),
    select && selectedClassName.text.replace(/active:/g, ""),
    select && selectedClassName.border.replace(/active:/g, "")
  );
};

export default useTagStyles;
